import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-play\"><defs><style type=\"text/css\"></style></defs><path d=\"M513 61c249.08 0 451 201.92 451 451S762.08 963 513 963 62 761.08 62 512 263.92 61 513 61z m-72.752 266.918c-20.82 0-37.697 16.94-37.697 37.837v301.69c0 7.35 2.132 14.54 6.137 20.692 11.386 17.495 34.746 22.413 52.176 10.985L688.25 550.037a39.865 39.865 0 0 0 11.552-11.595c12.019-18.467 6.847-43.216-11.552-55.279L460.864 334.078a37.597 37.597 0 0 0-20.616-6.16z\" p-id=\"33247\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/play.svg
// module id = ufmG
// module chunks = 2